import { motion } from "framer-motion";
import { ArrowRight, Play } from "lucide-react";
import { Eyebrow, fadeUp } from "./shared";

export function Hero() {
  return (
    <header id="top" data-testid="hero" className="relative overflow-hidden bg-[#0C111C] text-[#F4EDE2]">
      <video
        src="/yaba_video.mp4"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 h-full w-full object-cover opacity-80"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0C111C] via-[#0C111C]/60 to-transparent" />
      {/* mask the bottom of the video to hide any burned-in watermark/tagline */}
      <div className="absolute inset-x-0 bottom-0 h-40 md:h-56 bg-gradient-to-t from-[#0C111C] via-[#0C111C]/80 to-transparent pointer-events-none" />
      <div
        className="absolute inset-0 pointer-events-none mix-blend-overlay opacity-[0.08]"
        style={{
          background:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' /></filter><rect width='120' height='120' filter='url(%23n)' /></svg>\")",
        }}
      />
      <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 lg:px-20 pt-24 pb-32 md:pt-40 md:pb-48">
        <motion.div initial="hidden" animate="show" variants={fadeUp}>
          <Eyebrow>SS26 launch collection</Eyebrow>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 max-w-5xl"
          style={{
            fontFamily: "Fraunces, serif",
            fontSize: "clamp(48px, 8vw, 128px)",
            lineHeight: 0.94,
            letterSpacing: "-0.02em",
          }}
        >
          Traditional wear.
          <br />
          <span className="text-[#C8A96A]">Reimagined for the world.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mt-8 max-w-xl text-base md:text-lg text-[#F4EDE2]/85"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          Handcrafted Moroccan jellabas — modern silhouette, premium viscose, delivered internationally.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.7 }}
          className="mt-10 flex flex-wrap gap-3"
        >
          <a
            href="#the-collection"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-3 rounded-full bg-[#C8A96A] px-8 py-4 text-[#0C111C] font-medium hover:bg-[#F4EDE2] transition-colors"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            Shop the collection <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </a>
          <button
            data-testid="hero-cta-secondary"
            className="group inline-flex items-center gap-3 rounded-full border border-[#F4EDE2]/40 px-8 py-4 text-[#F4EDE2] hover:border-[#C8A96A] hover:text-[#C8A96A] transition-colors"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            <Play size={16} /> Watch the film
          </button>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.0 }}
          className="mt-16 flex flex-wrap gap-x-8 gap-y-2 text-[11px] tracking-[0.2em] uppercase text-[#F4EDE2]/75"
          style={{ fontFamily: "Inter, sans-serif" }}
        >
          <span>Handcrafted in Fes</span>
          <span className="text-[#C8A96A]">·</span>
          <span>Free shipping</span>
          <span className="text-[#C8A96A]">·</span>
          <span>Machine washable</span>
          <span className="text-[#C8A96A]">·</span>
          <span>30-day returns</span>
        </motion.div>
      </div>
    </header>
  );
}
